import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Separator, LabelTooltip, Avatar } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { toggleVisible, toggleAllVisible } from '../../../services/personService'

const floatRight = css`
  float: right;
`

function HideButtonAndExtras({ metadata, personChangesDispatch, personChangeGroup }) {
  const { t } = useTranslation()
  const hideButtonHandler = () => {
    toggleVisible(!metadata.hidden, metadata.targetEntityType, metadata.targetEntityId, metadata.changeId).then(() => {
      const action = {
        type: 'toggleHide',
        changeId: metadata.changeId,
        hidden: !metadata.hidden,
      }
      personChangesDispatch(action)
    })
  }
  const hideGroupButtonHandler = () => {
    const changesToToggle = !metadata.groupHidden
      ? personChangeGroup.filter((personChange) => !personChange.metadata.hidden)
      : personChangeGroup
    const requestBody = changesToToggle.map((personChange) => {
      return {
        hidden: !personChange.metadata.hidden,
        targetEntityType: personChange.metadata.targetEntityType,
        targetEntityId: personChange.metadata.targetEntityId,
        changeId: personChange.metadata.changeId,
      }
    })
    toggleAllVisible(requestBody).then(() => {
      const updatedChangeIds = requestBody.map((change) => change.changeId)
      const action = {
        type: 'toggleHideGroup',
        changeIds: updatedChangeIds,
        hidden: !metadata.groupHidden,
      }
      personChangesDispatch(action)
    })
  }
  return (
    <span key={`metadata.${metadata.targetEntityId}`}>
      <span css={floatRight}>
        {metadata.isTopGroupChange && (
          <>
            <Button id="hideUnhideGroupButton" onClick={() => hideGroupButtonHandler()} emphasis="medium">
              {metadata.groupHidden ? t('person.changes.unhideGroup', 'Unhide Group') : t('hideGroup', 'Hide Group')}
            </Button>
            <Separator size="xs" />
          </>
        )}
        <span css={floatRight}>
          <Button id="hideUnhideButton" onClick={() => hideButtonHandler()} emphasis="medium">
            {metadata.hidden ? t('person.changes.unhide', 'Unhide') : t('hide', 'Hide')}
          </Button>
        </span>
        <Separator size="lg" />
        {metadata.hidden && (
          <span css={floatRight}>
            <LabelTooltip label={t('hidden', 'Hidden')} target={<Avatar size="xs" monogram="H" />} />
          </span>
        )}
        {metadata.undoable && (
          <span css={floatRight}>
            <LabelTooltip label={t('person.changes.undoable', 'Undoable')} target={<Avatar size="xs" monogram="U" />} />
          </span>
        )}
        {metadata.current && (
          <span css={floatRight}>
            <LabelTooltip label={t('current', 'Current')} target={<Avatar size="xs" monogram="C" />} />
          </span>
        )}
      </span>
    </span>
  )
}

export default HideButtonAndExtras
